<form>
  <div class="input-chips flex-wrap" *ngIf="chips.length > 0">
    <span *ngFor="let chip of chips; let i = index">
      {{ chip }}
      <cite (click)="removeChip(i)">
        <img src="assets/images/close-white.svg" alt="X" />
      </cite>
    </span>
  </div>
  <textarea
    placeholder="Type the tag name and press Enter."
    (keyup.enter)="addChipValue($event)"
  ></textarea>
</form>
